// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ContentTabGroup_tabs__YrHvg","cancelButton":"ContentTabGroup_cancelButton__1Xzp_"};